module.exports = __webpack_public_path__ + "img/both-eyes.e5d5cd75.svg";